// extracted by mini-css-extract-plugin
export default {"HelperLabel":"HelperLabel_HelperLabel__tcNVA","HelperText":"HelperLabel_HelperText__l-4q4"};